import { render, staticRenderFns } from "./ato.vue?vue&type=template&id=187bf53e"
import script from "./ato.vue?vue&type=script&lang=js"
export * from "./ato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports